export const DEFAULT_MINUTES_TO_REOPEN_KIOSK = 20;

export const DEFAULT_SCREENSAVER_PERIOD = 'PT20S';

export const CLOSE_EVENT_FALLBACK_TIMEOUT_MS = 20000;
